var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainFirmwareSetting"},[_c('router-view',{attrs:{"route-model":_vm.routeModel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }